<template>
  <div class="my-5 bg-white shadow-sm sm:rounded-md">
    <div class="px-5 py-5">
      <div class="text-lg leading-6 font-medium text-gray-900">
        {{ t('socialCampaigns.jobmarketingTitle') }}
      </div>
      <div class="mt-1 text-sm font-normal text-gray-900">
        {{ t('socialCampaigns.jobmarketingDescription') }}
      </div>
      <div class="mt-5 flex items-center justify-between rounded-sm p-5">
        <div class="flex items-center">
          <img
            class="w-24"
            src="/free_advice.png"
            alt="Logo Jobsrepublic Publisher"
          />
          <span class="mt-8 -ml-5 text-xl text-gray-600 uppercase">{{
            t('socialCampaigns.freeAdvice')
          }}</span>
        </div>

        <Toggle
          srLabel="Job marketing"
          :checked="vacancyStore.hasRecruitmentMarketingAdvice"
          :onToggle="onToggle"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Toggle from '../Toggle.vue'
import { useI18n } from 'vue-i18n'
import { useVacancyStore } from '../../store/vacancyStore'

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})
const vacancyStore = useVacancyStore()

const onToggle = () => {
  vacancyStore.hasRecruitmentMarketingAdvice =
    !vacancyStore.hasRecruitmentMarketingAdvice
}
</script>
